var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { WithIcon } from "../_primitives/WithIcon.js";
import { Link, useMatch } from "react-router-dom";
import { WithTooltip } from "../_primitives/WithTooltip.js";
import classNames from "classnames";
export const QuiNavButton = forwardRef(function QuiNavButton(_a, ref) {
    var { to, external, download, tooltip, tooltipProps, iconLeft, iconRight, children, variant, disabled, style, className } = _a, otherProps = __rest(_a, ["to", "external", "download", "tooltip", "tooltipProps", "iconLeft", "iconRight", "children", "variant", "disabled", "style", "className"]);
    const match = useMatch(to !== null && to !== void 0 ? to : "");
    // If it's a link, make it look active it matches the current route/URL
    const actualVariant = match && to ? "filled" : variant !== null && variant !== void 0 ? variant : "outline";
    const cn = classNames("qui-nav-button", `qui-nav-button-${actualVariant}`, className);
    // The inner content
    const content = (React.createElement(WithTooltip, { tooltip: tooltip, tooltipProps: tooltipProps },
        React.createElement(WithIcon, { iconLeft: iconLeft, iconRight: iconRight }, children)));
    if (to && disabled) {
        return React.createElement("span", null, content);
    }
    if (to && (external || download)) {
        return (React.createElement("a", { className: cn, style: style, ref: ref, href: to, download: download === true }, content));
    }
    if (to) {
        return (React.createElement(Link, { className: cn, style: style, ref: ref, to: to }, content));
    }
    return (React.createElement("button", Object.assign({ className: cn, style: style, disabled: disabled, type: "button", ref: ref }, otherProps), content));
});
